import React from 'react';
import { Logo } from '@nearst/ui';
import styles from './Sidebar.module.scss';

export const ConditionalLogo = () => {
	return <Logo height="24px" className={styles.logo} style={{ display: 'block' }} />;
};
